enum CheckoutPaymentStatus {
  Processing = 'processing',
  Successful = 'successful',
  Failed = 'failed',
}

export default CheckoutPaymentStatus;
